import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ConfigOptions, ConfigService } from '@wilson/config';
import { ShiftDrawerMode, ShiftSetting } from '@wilson/interfaces';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ShiftSettingsGatewayService {
  protected readonly config = inject<ConfigOptions>(ConfigService);
  protected readonly http = inject(HttpClient);

  protected readonly path = 'shift-settings';

  get(): Observable<ShiftSetting> {
    return this.http.get<ShiftSetting>(`${this.config.host}/${this.path}`);
  }

  update(shiftDrawerMode: ShiftDrawerMode): Observable<ShiftSetting> {
    return this.http.patch<ShiftSetting>(`${this.config.host}/${this.path}`, {
      shiftDrawerMode,
    });
  }
}
